var elevatorInsuranceSearch = function (elevator_type, building_use, building_floor, capacity, capacity_input,
                                        elevator_build_year, discount, has_door, financial_loss, loss_number, medical_cost) {
    function showFieldError($field, message) {
        var $target = $field;
        if ($field && $field.length) {
            if ($field.hasClass('select2-hidden-accessible')) {
                $target = $field.next('.select2');
            } else if ($field.next('.select2').length) {
                $target = $field.next('.select2');
            } else if ($field.next().length && !$field.is('input[type="text"], input[type="tel"], textarea')) {
                $target = $field.next();
            }
            try {
                $target.animateCss('shake');
            } catch (e) {}
            $target.addClass('elevator-field-error');
            setTimeout(function () {
                $target.removeClass('elevator-field-error');
            }, 2500);
        }
        if (typeof Swal !== 'undefined') {
            Swal.fire({
                icon: 'warning',
                title: 'توجه',
                text: message,
                confirmButtonText: 'باشه',
                confirmButtonColor: '#ED6D37'
            });
        } else {
            alert(message);
        }
        return false;
    }

    if (elevator_type.val() == -1 || elevator_type.find("option:selected").text() == "") {
        return showFieldError(elevator_type, 'لطفاً کاربری آسانسور را انتخاب کنید.');
    }
    if (building_use.val() == -1 || building_use.val() == null || building_use.find("option:selected").text() == "") {
        return showFieldError(building_use, 'لطفاً کاربری ساختمان را انتخاب کنید.');
    }
    if (building_floor.val() == -1 || building_floor.val() == null || building_floor.find("option:selected").text() == "") {
        return showFieldError(building_floor, 'لطفاً تعداد طبقات توقف آسانسور را انتخاب کنید.');
    }

    if (elevator_build_year.val() == -1 || elevator_build_year.val() == null || elevator_build_year.find("option:selected").text() == "") {
        return showFieldError(elevator_build_year, 'لطفاً سال نصب و راه‌اندازی آسانسور را انتخاب کنید.');
    }
    if ((discount.val() == -1 && discount.find("option:selected").text() == "" )|| discount.val() == null) {
        return showFieldError(discount, 'لطفاً سابقه عدم خسارت را انتخاب کنید.');
    }

    if(elevator_type.find('option[value='+elevator_type.val()+']').text() != 'نفربر'){
        if (financial_loss.val() == '' || financial_loss.val() == -1 || financial_loss.val() == null) {
            return showFieldError(financial_loss, 'لطفاً خسارت مالی در هر حادثه را انتخاب کنید.');
        }
        if (loss_number.val() == -1 || loss_number.val() == null || loss_number.find("option:selected").text() == "") {
            return showFieldError(loss_number, 'لطفاً حداکثر خسارت مالی طی مدت بیمه را انتخاب کنید.');
        }
    }

    if(elevator_type.find('option[value='+elevator_type.val()+']').text() != 'باربر'){
        if (capacity.val() == -1 || capacity.val() == null || capacity.val() == 'null' ) {
            return showFieldError(capacity, 'لطفاً ظرفیت آسانسور را انتخاب کنید.');
        }
        if (medical_cost.val() == -1 || medical_cost.val() == null || medical_cost.val() == 'null' || medical_cost.find("option:selected").text() == "") {
            return showFieldError(medical_cost, 'لطفاً هزینه پزشکی برای هر نفر را انتخاب کنید.');
        }
    }else{
        if (capacity_input.val() == '' || capacity_input.val() == null || capacity_input.val() == 'null') {
            return showFieldError(capacity_input, 'لطفاً ظرفیت آسانسور را وارد کنید.');
        }
    }

    var url_param = '';
    var elevatortype = elevator_type.val();
    var buildinguse = building_use.val();
    var buildingfloor = building_floor.val();
    var Capacity = capacity.val();
    var capacityinput = capacity_input.val();
    var elevatorbuildyear = elevator_build_year.val();
    var Discount = discount.val();
    var hasdoor = has_door.is(':checked');
    var financialloss = financial_loss.val();
    var lossnumber = loss_number.val();
    var medicalcost = medical_cost.val();



    url_param += '?elevatorType=' + elevatortype;
    url_param += '&buildingUse=' + buildinguse;
    url_param += '&buildingFloor=' + buildingfloor;
    if (Capacity && Capacity != -1) {
        url_param += '&capacity=' + Capacity;
    }
    else{
        url_param += '&capacity=' + capacityinput;
    }
    url_param += '&buildYear=' + elevatorbuildyear;
    url_param += '&discount=' + Discount;
    url_param += '&hasDoor=' + hasdoor;
    if(elevator_type.find('option[value='+elevator_type.val()+']').text() != 'نفربر'){
        url_param += '&financialLoss=' + financialloss;
        url_param += '&lossNumber=' + lossnumber;
    }
    if(elevator_type.find('option[value='+elevator_type.val()+']').text() != 'باربر'){
        url_param += '&medicalCost=' + medicalcost;
    }

    window.location = elevatorInsuranceSearchUrl + '/' + url_param;
}
$(document).ready(function () {
    $('.elevator_insurance_searchBtn_top').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var elevator_type = $('#elevator_type_select');
        var building_use = $('#building_use_select');
        var building_floor = $('#building_floor_select');
        var capacity = $('#capacity_select');
        var capacity_input = $('#capacity_input');
        var elevator_build_year = $('#elevator_build_year_select');
        var discount = $('#discount_select');
        var has_door = $('#has_door_check');
        var financial_loss = $('#elevator_financial_loss_select');
        var loss_number = $('#financial_loss_number_select');
        var medical_cost = $('#elevator_medical_cost_select');

        elevatorInsuranceSearch(elevator_type, building_use, building_floor, capacity, capacity_input, elevator_build_year,
            discount, has_door, financial_loss, loss_number,medical_cost);
        return false;
    });
});

$.fn.extend(
    {
        animateCss: function (animationName) {
            var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            this.addClass('animated ' + animationName).one(
                animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                }
            );
        }
    }
);
